"use client";
import React, { useState } from "react";

const InsightsBottom = () => {
  const [asspectsFilterBtn, setAsspectsFilterBtn] =
    useState("Positive Aspects");
  const [openAsspectsSection, setOpenAsspectsSection] =
    useState("Increasing Revenue");

  const handleAsspectsFilter = (asspects) => {
    setAsspectsFilterBtn(asspects);
  };

  const handleToggle = (section) => {
    setOpenAsspectsSection((prevSection) =>
      prevSection === section ? null : section
    );
  };

  return (
    <div className="border border-solid border-[#E0E0E0] p-4 gap-4 w-[393px] h-max rounded-lg">
      <div className="flex justify-center items-center">
        <div className="flex justify-between items-center mt-4 mb-2 rounded-full w-[70%] bg-[#F1F1F6]">
          <button
            onClick={() => handleAsspectsFilter("Positive Aspects")}
            className={`text-xs font-bold px-2 py-1 text-[#848484] ${
              asspectsFilterBtn === "Positive Aspects"
                ? "bg-[#A0FF77] !text-[#262626] rounded-full m-0.5 py-1"
                : ""
            }`}
          >
            Positive Aspects
          </button>
          <button
            className={`text-xs font-bold px-2 py-1 text-[#848484] ${
              asspectsFilterBtn === "Negative Aspects"
                ? "bg-[#A0FF77] !text-[#262626] rounded-full m-0.5 py-1"
                : ""
            }`}
            onClick={() => handleAsspectsFilter("Negative Aspects")}
          >
            Negative Aspects
          </button>
        </div>
      </div>
      {asspectsFilterBtn === "Positive Aspects" ? (
        <>
          <div
            className={`flex flex-col w-[361px]  cursor-pointer rounded-lg border  border-solid border-[#12AC2140]   ${
              openAsspectsSection === "Increasing Revenue"
                ? "mb-3 h-max "
                : "mb-3  h-[32px] "
            }`}
          >
            <div
              onClick={() => handleToggle("Increasing Revenue")}
              className={` flex flex-row justify-between mx-2 my-1 `}
            >
              <p className="font-semibold text-sm  ">Increasing Revenue</p>
              {openAsspectsSection !== "Increasing Revenue" ? (
                <img
                  src="/images/downarrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              ) : (
                <img
                  src="/images/uparrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              )}
            </div>
            {openAsspectsSection === "Increasing Revenue" && (
              <div className="px-2 pt-1 pb-2">
                <div className="border-b border-[#C4EAC8]"></div>
                <p className="text-xs font-medium text-[#555555] pt-2">
                  {" "}
                  The company's revenue has been growing steadily over the past
                  12 months, indicating a positive trend in its business
                  operations.
                </p>
              </div>
            )}
          </div>

          <div
            className={`flex flex-col w-[361px]  cursor-pointer rounded-lg border  border-solid border-[#12AC2140]   ${
              openAsspectsSection === "Strong Interest Income"
                ? "mb-3 h-max "
                : "mb-3  h-[32px] "
            }`}
          >
            <div
              onClick={() => handleToggle("Strong Interest Income")}
              className={` flex flex-row justify-between mx-2 my-1 `}
            >
              <p className="font-semibold text-sm  ">Strong Interest Income</p>
              {openAsspectsSection !== "Strong Interest Income" ? (
                <img
                  src="/images/downarrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              ) : (
                <img
                  src="/images/uparrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              )}
            </div>
            {openAsspectsSection === "Strong Interest Income" && (
              <div className="px-2 pt-1 pb-2">
                <div className="border-b border-[#C4EAC8]"></div>
                <p className="text-xs font-medium text-[#555555] pt-2">
                  Interest income has also been rising, suggesting growth in the
                  company's lending or investment activities.
                </p>
              </div>
            )}
          </div>

          <div
            className={`flex flex-col w-[361px]  cursor-pointer rounded-lg border  border-solid border-[#12AC2140]   ${
              openAsspectsSection === "High Financing Margin"
                ? "mb-3 h-max "
                : "mb-3  h-[32px] "
            }`}
          >
            <div
              onClick={() => handleToggle("High Financing Margin")}
              className={` flex flex-row justify-between mx-2 my-1 `}
            >
              <p className="font-semibold text-sm  ">High Financing Margin</p>
              {openAsspectsSection !== "High Financing Margin" ? (
                <img
                  src="/images/downarrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              ) : (
                <img
                  src="/images/uparrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              )}
            </div>
            {openAsspectsSection === "High Financing Margin" && (
              <div className="px-2 pt-1 pb-2">
                <div className="border-b border-[#C4EAC8]"></div>
                <p className="text-xs font-medium text-[#555555] pt-2">
                  The company has maintained a strong financing margin of 16-18%
                  over the past year, indicating efficient use of funds for
                  profitability.
                </p>
              </div>
            )}
          </div>

          <div
            className={`flex flex-col w-[361px]  cursor-pointer rounded-lg border  border-solid border-[#12AC2140]   ${
              openAsspectsSection === "Growing Other Income"
                ? "mb-3 h-max "
                : "mb-3  h-[32px] "
            }`}
          >
            <div
              onClick={() => handleToggle("Growing Other Income")}
              className={` flex flex-row justify-between mx-2 my-1 `}
            >
              <p className="font-semibold text-sm  ">Growing Other Income</p>
              {openAsspectsSection !== "Growing Other Income" ? (
                <img
                  src="/images/downarrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              ) : (
                <img
                  src="/images/uparrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              )}
            </div>
            {openAsspectsSection === "Growing Other Income" && (
              <div className="px-2 pt-1 pb-2">
                <div className="border-b border-[#C4EAC8]"></div>
                <p className="text-xs font-medium text-[#555555] pt-2">
                  {" "}
                  Other income, which typically includes dividends and capital
                  gains, has been increasing, adding to the company's overall
                  profit
                </p>
              </div>
            )}
          </div>

          <div
            className={`flex flex-col w-[361px]  cursor-pointer rounded-lg border  border-solid border-[#12AC2140]   ${
              openAsspectsSection === "Consistent Earnings per Share (EPS)"
                ? "mb-3 h-max "
                : "mb-3  h-[32px] "
            }`}
          >
            <div
              onClick={() =>
                handleToggle("Consistent Earnings per Share (EPS)")
              }
              className={` flex flex-row justify-between mx-2 my-1 `}
            >
              <p className="font-semibold text-sm  ">
                Consistent Earnings per Share (EPS)
              </p>
              {openAsspectsSection !== "Consistent Earnings per Share (EPS)" ? (
                <img
                  src="/images/downarrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              ) : (
                <img
                  src="/images/uparrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              )}
            </div>
            {openAsspectsSection === "Consistent Earnings per Share (EPS)" && (
              <div className="px-2 pt-1 pb-2">
                <div className="border-b border-[#C4EAC8]"></div>
                <p className="text-xs font-medium text-[#555555] pt-2">
                  {" "}
                  The EPS has remained relatively stable over the past 12
                  months, indicating a consistent performance.
                </p>
              </div>
            )}
          </div>

          <div
            className={`flex flex-col w-[361px]  cursor-pointer rounded-lg border  border-solid border-[#12AC2140]   ${
              openAsspectsSection === "Healthy Net Profit Margin"
                ? "mb-3 h-max "
                : "mb-3  h-[32px] "
            }`}
          >
            <div
              onClick={() => handleToggle("Healthy Net Profit Margin")}
              className={` flex flex-row justify-between mx-2 my-1 `}
            >
              <p className="font-semibold text-sm  ">
                Healthy Net Profit Margin
              </p>
              {openAsspectsSection !== "Healthy Net Profit Margin" ? (
                <img
                  src="/images/downarrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              ) : (
                <img
                  src="/images/uparrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              )}
            </div>
            {openAsspectsSection === "Healthy Net Profit Margin" && (
              <div className="px-2 pt-1 pb-2">
                <div className="border-b border-[#C4EAC8]"></div>
                <p className="text-xs font-medium text-[#555555] pt-2">
                  {" "}
                  The company has achieved net profit margins of over 10% in
                  recent quarters, suggesting efficient operations and
                  profitability.
                </p>
              </div>
            )}
          </div>
          <div
            className={`flex flex-col w-[361px]  cursor-pointer rounded-lg border  border-solid border-[#12AC2140]   ${
              openAsspectsSection === "Low Gross and Net NPA Ratio"
                ? "mb-3 h-max "
                : "  h-[32px] "
            }`}
          >
            <div
              onClick={() => handleToggle("Low Gross and Net NPA Ratio")}
              className={` flex flex-row justify-between mx-2 my-1 `}
            >
              <p className="font-semibold text-sm  ">
                Low Gross and Net NPA Ratios
              </p>
              {openAsspectsSection !== "Low Gross and Net NPA Ratio" ? (
                <img
                  src="/images/downarrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              ) : (
                <img
                  src="/images/uparrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              )}
            </div>
            {openAsspectsSection === "Low Gross and Net NPA Ratio" && (
              <div className="px-2 pt-1 pb-2">
                <div className="border-b border-[#C4EAC8]"></div>
                <p className="text-xs font-medium text-[#555555] pt-2">
                  The company's Gross and Net NPA ratios have been declining,
                  indicating a low level of bad debts and an improving credit
                  quality.
                </p>
              </div>
            )}
          </div>
        </>
      ) : asspectsFilterBtn === "Negative Aspects" ? (
        <>
          <div
            className={`flex flex-col w-[361px]  cursor-pointer rounded-lg border  border-solid border-[#D30D0040]   ${
              openAsspectsSection === "Financing Margin %"
                ? "mb-3 h-max "
                : "mb-3  h-[32px] "
            }`}
          >
            <div
              onClick={() => handleToggle("Financing Margin %")}
              className={` flex flex-row justify-between mx-2 my-1 `}
            >
              <p className="font-semibold text-sm  ">Financing Margin %</p>
              {openAsspectsSection !== "Financing Margin %" ? (
                <img
                  src="/images/downarrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              ) : (
                <img
                  src="/images/uparrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              )}
            </div>
            {openAsspectsSection === "Financing Margin %" && (
              <div className="px-2 pt-1 pb-2">
                <div className="border-b border-[#D30D0040]"></div>
                <p className="text-xs font-medium text-[#555555] pt-2">
                  {" "}
                  Has significantly declined from a peak of 18% in December 2022
                  to -3% in March 2024, indicating a sharp erosion in the
                  company's profitability.
                </p>
              </div>
            )}
          </div>

          <div
            className={`flex flex-col w-[361px]  cursor-pointer rounded-lg border  border-solid border-[#D30D0040]   ${
              openAsspectsSection === "Net Profit"
                ? "mb-3 h-max "
                : "mb-3  h-[32px] "
            }`}
          >
            <div
              onClick={() => handleToggle("Net Profit")}
              className={` flex flex-row justify-between mx-2 my-1 `}
            >
              <p className="font-semibold text-sm  ">Net Profit</p>
              {openAsspectsSection !== "Net Profit" ? (
                <img
                  src="/images/downarrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              ) : (
                <img
                  src="/images/uparrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              )}
            </div>
            {openAsspectsSection === "Net Profit" && (
              <div className="px-2 pt-1 pb-2">
                <div className="border-b border-[#D30D0040]"></div>
                <p className="text-xs font-medium text-[#555555] pt-2">
                  {" "}
                  Has fallen sharply from a high of 16373 in December 2023 to
                  16512 in March 2024, despite an increase in revenue.
                </p>
              </div>
            )}
          </div>

          <div
            className={`flex flex-col w-[361px]  cursor-pointer rounded-lg border  border-solid border-[#D30D0040]   ${
              openAsspectsSection === "EPS in Rs"
                ? "mb-3 h-max "
                : "mb-3  h-[32px] "
            }`}
          >
            <div
              onClick={() => handleToggle("EPS in Rs")}
              className={` flex flex-row justify-between mx-2 my-1 `}
            >
              <p className="font-semibold text-sm  ">EPS in Rs</p>
              {openAsspectsSection !== "EPS in Rs" ? (
                <img
                  src="/images/downarrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              ) : (
                <img
                  src="/images/uparrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              )}
            </div>
            {openAsspectsSection === "EPS in Rs" && (
              <div className="px-2 pt-1 pb-2">
                <div className="border-b border-[#D30D0040]"></div>
                <p className="text-xs font-medium text-[#555555] pt-2">
                  {" "}
                  Has also declined from a peak of 21.98 in March 2023 to 21.73
                  in March 2024, despite a slight increase in revenue.
                </p>
              </div>
            )}
          </div>

          <div
            className={`flex flex-col w-[361px]  cursor-pointer rounded-lg border  border-solid border-[#D30D0040]   ${
              openAsspectsSection === "Financing Profit"
                ? "mb-3 h-max "
                : "mb-3  h-[32px] "
            }`}
          >
            <div
              onClick={() => handleToggle("Financing Profit")}
              className={` flex flex-row justify-between mx-2 my-1 `}
            >
              <p className="font-semibold text-sm  ">Financing Profit</p>
              {openAsspectsSection !== "Financing Profit" ? (
                <img
                  src="/images/downarrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              ) : (
                <img
                  src="/images/uparrow.png"
                  alt=""
                  className="w-[20px] h-[20px]"
                />
              )}
            </div>
            {openAsspectsSection === "Financing Profit" && (
              <div className="px-2 pt-1 pb-2">
                <div className="border-b border-[#D30D0040]"></div>
                <p className="text-xs font-medium text-[#555555] pt-2">
                  {" "}
                  Has turned negative in March 2024, resulting in a loss of
                  -2404. This suggests that the company's interest expenses have
                  exceeded its interest income.
                </p>
              </div>
            )}
          </div>
        </>
      ) : null}
    </div>
  );
};

export default InsightsBottom;
